import * as yup from 'yup';
import { getPasswordStrengthTest } from '../../AppGrid/UserTable';
import consts from '../../consts';
import Model from '../../models/model';

const model = new Model({
	name: 'ForgotPassword',
	columns: [
		{
			field: 'email',
			header: 'EnterEmail',
			validate: 'isEmail',
			inlineLabelSize: 12,
			required: true,

		},
		{
			field: 'clientId',
			header: "Client",
			type: 'number',
			defaultValue: undefined,
			inlineLabelSize: 12,
			inputWhen: ({ activeRecord }) => (activeRecord.shouldChooseClient),
			required: ({ activeRecord }) => (activeRecord.shouldChooseClient),
			lookup: "userClients"

		},
		{
			field: 'token',
			header: 'EnterToken',
			inlineLabelSize: 12,
			inputWhen: ({activeRecord}) => activeRecord?.alreadyHaveToken,
			required: ({activeRecord}) => activeRecord?.alreadyHaveToken,
		},
		{
			field: 'password',
			header: 'Password',
			placeholder: "EnterNewPassword",
			type: 'password',
			inlineLabelSize: 12,
			inputWhen: ({activeRecord}) => activeRecord?.alreadyHaveToken,
			required: ({activeRecord}) => activeRecord?.alreadyHaveToken,
			validate: () => {
				let schema = yup.string();
				const strength = "Strong";
				const testObj = getPasswordStrengthTest(strength, consts.passwordStringMapper[strength], consts.PasswordStrength[strength]);
				schema = schema.test(testObj);
				return schema;
			}
		},
		{
			field: 'confirm',
			header: 'ConfirmPassword',
			placeholder: 'EnterConfirmPassword',
			type: 'password',
			inlineLabelSize: 12,
			inputWhen: ({activeRecord}) => activeRecord?.alreadyHaveToken,
			required: ({activeRecord}) => activeRecord?.alreadyHaveToken,
			validate: 'compare:password'
		},
	]
});

export default model.createFormDialog();
